import client from '../plugins/axios'
// for refresh
import axios from 'axios'
export default {
    registUser: async (user) => {
        return await client.post(`/auth/register`,
            user);
    }, login: async (email, passwd) => {
        return await client.post(`/auth/login`,
            { email, passwd });
    }, refreshToken: async (email, refreshToken) => {
        return await axios.post(`${client.defaults.baseURL}/auth/refreshToken`,
            { email, refreshToken });
    },
}



// WEBPACK FOOTER //
// ./src/api/auth.js